<div class="row" *ngFor="let de of entities">
  <div class="col">
    <div class="form-group">
      <wm-data-entity-group-layout-input
        *ngIf="de.type === 'group-data-entity-layout'"
        [layoutModel]="de"
        [form]="form"
        [isReadOnly]="true"
        [applicationId]="applicationId"
        [activity]="activity"
      >
      </wm-data-entity-group-layout-input>
      <wm-data-entity-table-layout-input
        *ngIf="de.type === 'table-data-entity-layout'"
        [layoutModel]="de"
        [form]="form"
        [applicationId]="applicationId"
        [isReadOnly]="true"
        [activity]="activity"
      >
      </wm-data-entity-table-layout-input>
      <wm-data-entity-row-layout-input
        *ngIf="de.type === 'row-data-entity-layout'"
        [layoutModel]="de"
        [form]="form"
        [applicationId]="applicationId"
        [isReadOnly]="true"
        [activity]="activity"
      >
      </wm-data-entity-row-layout-input>
      <wm-data-entity-view
        [entity]="de.entity"
        [form]="form"
        [applicationId]="applicationId"
        [activity]="activity"
      ></wm-data-entity-view>
    </div>
  </div>
</div>
